import React from "react";
import MainLayout from "../layout/MainLayout";
import Breadcrumbs from "../components/Breadcrumbs";

export default function OverviewMytel() {
  return (
    <>
      <MainLayout />
      <main className="container-item">
        <Breadcrumbs data={["Overview", "Mytel"]} />
        OverviewMytel
      </main>
    </>
  );
}
